import * as Yup from 'yup';

export const CreateBlastScheduleFormValidationSchema = () => {
    return Yup.object().shape({
        name: Yup.string().required(`Please enter a name for the blast schedule.`)
    });
};
